import { createStore } from 'vuex'

export default createStore({
  state: {
    pictureCategories: []
  },
  getters: {
    getPictureCategories: state => state.pictureCategories
  },
  mutations: {
    setPictureCategories(state, pictureCategories) {
      state.pictureCategories = pictureCategories;
    }
  },
  actions: {
  },
  modules: {
  }
})
